import Vue from 'vue';
import {store} from "./store-init";
import {imageIdToURL, assetsImg} from './utils';

let staticTitulo = (hash) => {
    const catalog = store.getters.catalogStaticContent;

    console.log('STATIC CONTENT:', catalog);
    console.log('BUSCANDO HASH:', hash);

    if(!catalog.length) return '';

    const item = catalog.find(content => content.hash === hash);

    console.log('ENCONTRADO:', item);

    return item ? item.title : (hash + '-titulo');
}

let staticContent = (hash) => {
    const catalog = store.getters.catalogStaticContent;
    if(!catalog.length) return '';
    const item = catalog.find(content => content.hash === hash);
    return item ? item.content : (hash + '-content');
}

let staticContentAlt = (hash) => {
    const catalog = store.getters.catalogStaticContent;
    if(!catalog.length) return '';
    const item = catalog.find(content => content.hash === hash);
    return item ? item.content_alt : (hash + '-content-alt');
}

let staticImg = (hash) => {
    const catalog = store.getters.catalogStaticContent;

    console.log('STATIC IMG CATALOG:', catalog);
    console.log('STATIC IMG HASH:', hash);

    if(!catalog.length) return '';

    const item = catalog.find(content => content.hash === hash);

    console.log('STATIC IMG ITEM:', item);

    let hardUrl;

    if (!/\.(jpeg|jpg|webp|png)$/i.test(hash)) {
        hardUrl = assetsImg('empty.svg');
    } else {
        hardUrl = assetsImg(hash);
    }

    return ((item && item.imagenes_id) ? imageIdToURL(item.imagenes_id) : hardUrl);
}

Vue.filter('staticContent', staticContent);
Vue.filter('staticContenido', staticContent);

Vue.filter('staticContentAlt', staticContentAlt);
Vue.filter('staticContenidoAlt', staticContentAlt);

Vue.filter('staticTitulo', staticTitulo);
Vue.filter('staticTitle', staticTitulo);

Vue.filter('staticImg', staticImg);

let contentReplace = (string) => {
    const contentReplacers = store.getters.catalogContentReplacers;

    if (!string || !contentReplacers) return string;

    return Object.keys(contentReplacers).reduce((content, key) => {
        const keyToReplace = key.trim().toLowerCase();
        if (!keyToReplace) return content;

        const escapedKey = keyToReplace.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        return content.replace(new RegExp(escapedKey, 'gi'), contentReplacers[key]);
    }, string);
}

Vue.filter('contentReplace', contentReplace);
Vue.filter('cr', contentReplace);